<script setup lang="ts">
const localePath = useLocalePath();
const { formatLink } = useInternationalization(localePath);
const { cartItems, isEmpty } = useCart();
</script>

<template>
  <div
    v-if="isEmpty"
    class="flex flex-col gap-4 justify-center items-center h-1/2"
  >
    <span class="pi pi-shopping-cart text-4xl text-primary-500" />

    <p class="text-lg font-bold">
      {{ $t("cart.emptyCartLabel") }}
    </p>
  </div>

  <div v-else class="flex flex-col flex-1 gap-y-4">
    <TransitionGroup
      name="list"
      tag="ul"
      class="overflow-x-hidden relative divide-y"
    >
      <CartItem
        v-for="cartItem in cartItems"
        :key="cartItem.id"
        :cart-item="cartItem"
      />
    </TransitionGroup>

    <div class="bg-surface-50 dark:bg-surface-800 p-2 rounded-lg shadow-sm">
      <CartFees />
    </div>

    <div class="static bottom-0 right-0 left-0 w-76 border-t space-y-4">
      <CartPromotionCode class="my-4" />

      <NuxtLink :to="formatLink('/checkout')" class="block">
        <Button class="w-full">{{ $t("cart.checkout") }}</Button>
      </NuxtLink>
    </div>
  </div>
</template>
